import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ports from './api/index'
Vue.use(Vuex);
let uri='/papi';
let uris='/api'
let acapi='/acapi';
export default new Vuex.Store({
    state:{
        user:{},
        notice:{
            unreadNum:0
        },
        parentInfo:{},
        studentStatus:1,//学生问卷完成情况
        parentStatus:1,//家长角色家长问卷完成情况
        citys:[],
        routeConfig:[],
        count:10,
    },
    mutations:{
        getRouteConfig(state, config){
            // console.log(state,'state');
            // console.log(config,'config')
            state.routeConfig = config;
            




        },
        //获取个人信息
        getUserInfo(state,data){
            state.user = data  
            sessionStorage.setItem('userData',JSON.stringify(data))
            // console.log(data)         
        },
        ///查看未读服务通知数量
        getUnreadNum(state,res){
            state.notice.unreadNum=res.data.data.num
        },
        //获取省市区
        getCitys(state,res){
            state.citys=res.data
        },
        getParentStatus(state,status) {
            state.parentStatus = status;
        },
        getStudentStatus(state,status) {
            state.studentStatus = status;
            console.log(status)
        },
        
        detailParentInfo(state,data) {
            state.parentInfo = data;           
        },
        add(state) {
            state.count++
          },
          reduce(state) {
            state.count--
          }
    },
    actions:{
        ///获取个人信息
        
        getUserInfo(context,item){
            
            axios.post(uri+ports.user.getUserInfo,{},{
                headers:{
                    token: item.token
                }
            }).then((res)=>{
              if(res.data.code==2000){
                    context.commit('getUserInfo',res.data.data)
                  let {userType,status} = res.data.data;
                     if(userType==1){
                          sessionStorage.setItem('userType','student')
                     }
                      if(userType==2){
                          sessionStorage.setItem('userType','parent')
                        if(item.vue.$route.path=='/careerArchives'){
                            if (status == 3) {
                                item.vue.$router.push('/parent/home/quesMessage');
                            } else {
                                item.vue.$router.push('/parent/home/ques');
                            }
                        }
                      }
                      if(userType==3){
                          sessionStorage.setItem('userType','consultant')
                          if(item.vue.$route.path=='/careerArchives'){
                              item.vue.$router.push('/consultant/home')
                          }
                      }
              }else if(res.data.code==2026){
                  item.vue.$router.push('/perfectInformation');
                }else{
                  window.localStorage.clear();
                  item.vue.$router.push('/login')
              }
            })
        },
        //查看未读服务通知数量
        getUnreadNum(context,token){
            let _this=this;
            axios.post(uri+ports.notice.getUnreadNum,{},{
                headers:{
                    token: token
                }
            }).then((res)=>{
                context.commit('getUnreadNum',res)
            })
        },
        //获取省市区
        getCitys(context) {
            let _this = this;
            axios.get('/data/map.json', {}, {
            }).then((res) => {
                context.commit('getCitys', res)
            })
        },
      
        getParentStatus(context,token) {
            axios.post(acapi + ports.parent.message.detailParentCensusQuestion,{},{
                headers:{
                    token: token
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let status = res.data.data.status;
                    context.commit('getParentStatus',status)
                }
            })
        },
        getStudentStatus(context,token) {
            axios.post(acapi + ports.student.message.getStudentSchedule,{},{
                headers:{
                    token: token
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let status = res.data.data.status;
                    context.commit('getStudentStatus',status)
                }
            })
        },
        // 获取家长是否绑定学生，及绑定的信息
        detailParentInfo(context,token) {
            axios.post(acapi + ports.parent.message.detailParentInfo,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let data = res.data.data;
                    context.commit('detailParentInfo',data)
                }
            })
        },
       
    }
})
